import { render, staticRenderFns } from "./TableCardL.vue?vue&type=template&id=20db1c74&scoped=true&"
import script from "./TableCardL.vue?vue&type=script&lang=js&"
export * from "./TableCardL.vue?vue&type=script&lang=js&"
import style0 from "./TableCardL.vue?vue&type=style&index=0&id=20db1c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20db1c74",
  null
  
)

export default component.exports